import { getRequestConfig } from 'api';
import { GmailMessage, ReplyEmailPayload, SendEmailPayload } from 'Interfaces/EmailInterface';
import { JSONInterface } from 'Interfaces/JsonInterface';

export const getGmailStatus = (): Promise<{ status: string }> => {
  const config = getRequestConfig();
  return fetch('/json/gmail/status', config).then(r => r.json());
};

export const getGmailMessages = (from: string): Promise<GmailMessage[]> => {
  const config = getRequestConfig();
  return fetch(`/json/gmail/getMessages?from=${encodeURIComponent(from)}`, config).then(r => r.json());
};

export const getGmailMessagesByCompany = (id: string): Promise<GmailMessage[]> => {
  const config = getRequestConfig();
  return fetch(`/json/gmail/company/${encodeURIComponent(id)}`, config).then(r => r.json());
};

export const getGmailThread = (threadId: string, userId: number): Promise<GmailMessage[]> => {
  const config = getRequestConfig();
  return fetch(`/json/gmail/getThread?id=${threadId}&userId=${userId}`, config).then(r => r.json());
};

export const sendEmail = (payload: SendEmailPayload): Promise<JSONInterface> => {
  const config = getRequestConfig();
  return fetch('/json/gmail/send', {
    ...config,
    method: 'POST',
    headers: { ...config.headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
};

export const sendReply = (payload: ReplyEmailPayload): Promise<JSONInterface> => {
  const config = getRequestConfig();
  return fetch('/json/gmail/reply', {
    ...config,
    method: 'POST',
    headers: { ...config.headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
};
